import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, ViewController } from 'ionic-angular';
import { AppConfig } from '../../../../app/app.config';

@Component({
  selector: 'warning-modal',
  templateUrl: './warning-modal.component.html',
})

export class WarningModalComponent implements OnInit {
  config = AppConfig.settings;
  title: string;
  item: string;
  message: string;
  optionalMessage: string;
  confirmText: string = 'Confirm';

  loading: boolean;

  constructor(
    params: NavParams,
    public viewController: ViewController,
    public modalController: ModalController,
  ) {
    this.title = params.get('title');
    this.message = params.get('message');
    this.item = params.get('comment');
    this.optionalMessage = params.get('optionalMessage');
    const confirmText = params.get('confirmText');

    if (!!confirmText) {
      this.confirmText = confirmText;
    }
  }

  async ngOnInit() {
    this.loading = false;
  }

  closeModal() {
    this.viewController.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/shared/components/warning-modal/warning-modal.component.ts